import { useSyncExternalStore } from 'react'

const subscribe = () => () => {}

/**
 * False while the page is rendered on the server and during hydration, true afterwards.
 * Use it to render values that depend on the visitor's browser, such as their time zone.
 */
export const useMounted = (): boolean => {
    return useSyncExternalStore(subscribe, () => true, () => false)
}
